
(function() {
  var result = { translations: { "uk": { "i18n": { "duration": { "seconds": "{{ seconds }} \u0441\u0435\u043A\u0443\u043D\u0434", "minutes": "{{ minutes }} \u0445\u0432\u0438\u043B\u0438\u043D", "hours": "{{ hours }} \u0433\u043E\u0434\u0438\u043D", "hoursAndMinutes": "{{ hours }} \u0433\u043E\u0434\u0438\u043D {{ minutes }} \u0445\u0432\u0438\u043B\u0438\u043D", "days": "{{ days }} \u0434\u043D\u0456\u0432", "shortForm": { "seconds": "{{ seconds }}\u0441", "minutes": "{{ minutes }}\u0445\u0432", "hours": "{{ hours }}\u0433\u043E\u0434", "days": "{{ days }}\u0434", "hoursAndMinutes": "{{ hours }}\u0433\u043E\u0434 {{ minutes }}\u0445\u0432" } }, "dateTime": { "quarterAndYear": "\u041A\u0432.{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, \u0434\u043E\u0434. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "uk": "static-7.1084"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1084",
    "ar-eg": "static-7.1084",
    "bg": "static-7.1084",
    "bn": "static-7.1084",
    "ca-es": "static-7.1084",
    "cs": "static-7.1084",
    "da": "static-7.1084",
    "de": "static-7.1084",
    "el": "static-7.1084",
    "en-gb": "static-7.1084",
    "en": "static-7.1084",
    "es-mx": "static-7.1084",
    "es": "static-7.1084",
    "et": "static-7.1084",
    "fi": "static-7.1084",
    "fr-ca": "static-7.1084",
    "fr": "static-7.1084",
    "he-il": "static-7.1084",
    "hi": "static-7.1084",
    "hr": "static-7.1084",
    "hu": "static-7.1084",
    "id": "static-7.1084",
    "it": "static-7.1084",
    "ja": "static-7.1084",
    "ko": "static-7.1084",
    "lt": "static-7.1084",
    "ms": "static-7.1084",
    "nl": "static-7.1084",
    "no": "static-7.1084",
    "pl": "static-7.1084",
    "pt-br": "static-7.1084",
    "pt-pt": "static-7.1084",
    "ro": "static-7.1084",
    "ru": "static-7.1084",
    "sk": "static-7.1084",
    "sl": "static-7.1084",
    "sv": "static-7.1084",
    "th": "static-7.1084",
    "tl": "static-7.1084",
    "tr": "static-7.1084",
    "uk": "static-7.1084",
    "vi": "static-7.1084",
    "x-pseudo": "static-7.1084",
    "zh-cn": "static-7.1084",
    "zh-hk": "static-7.1084",
    "zh-tw": "static-7.1084"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:uk', {version: 'static-7.1084'}); }
})();


